<template>
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow" v-if="model">
        <div class="team-list">
            <div class="title" data-aos="fade-in">
                <SmartLinkStandaloneElement :codename="type.elements.title.codename">               
                    <h2>{{ model?.elements?.title?.value }}</h2>
                </SmartLinkStandaloneElement>                
            </div>
            <div class="description" data-aos="fade-in">
                <SmartLinkStandaloneElement :codename="type.elements.description.codename">
                    <p>{{ model?.elements?.description?.value }}</p>
                </SmartLinkStandaloneElement>
            </div>
            <div class="team-member-container" data-aos="fade-in">
                <SmartLinkStandaloneElement :codename="type.elements.styling_options.codename">
                    <div class="row">
                        <TeamMember v-for="item in pageStore.getListAs<TeamMemberModel>(model.elements.team.value)" :full-information="fullInformation" :model="item" />
                    </div>
                </SmartLinkStandaloneElement>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { contentTypes, type TeamListModel, type TeamMemberModel } from '~~/app/models';
import TeamMember from '../blocks/TeamMember.vue';
const type = contentTypes.team_list;

const props = defineProps<{ model: TeamListModel }>();
const pageStore = usePageStore();
const fullInformation = computed(() => firstOrDefault(props.model.elements.styling_options.value)?.codename == 'full_information');
</script>